import React from 'react';
import type { ComponentProps, ReactElement } from 'react';

import { bulletListSelector } from '@atlaskit/adf-schema/bullet-list';
import type { BulletList as OriginalBulletList } from '@atlaskit/renderer/nodes';

import type { LightNodeProps } from '../LightNodeObserver.ts';

export const BulletList = (
	props: ComponentProps<typeof OriginalBulletList> & LightNodeProps,
): ReactElement => {
	const indentLevel =
		1 +
		(props.path?.filter(
			(node) => node.type.name === 'bulletList' || node.type.name === 'orderedList',
		).length ?? 0);
	return (
		<ul
			ref={props.lightNodeRef}
			// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Preserve Platform list styling and nested marker selectors.
			className={bulletListSelector.slice(1)}
			data-local-id={props.localId}
			data-indent-level={indentLevel}
		>
			{props.children}
		</ul>
	);
};
